(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-cart"]) return;
  try {
    
(function () {
  if (window.__rscart) return; window.__rscart = true;
  function rootEl() { return document.querySelector('[data-rscart]'); }
  function money(c) { return '£' + (Number(c) / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m]; }); }
  function post(url, data) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); }); }
  function notify() { ['cart:update', 'cart:refresh'].forEach(function (t) { document.dispatchEvent(new CustomEvent(t)); }); }
  function msg(html, err) { var m = rootEl() && rootEl().querySelector('[data-rscart-msg]'); if (!m) return; m.innerHTML = html; m.hidden = !html; m.classList.toggle('is-err', !!err); }
  var lastRemoved = null;

  function refresh(after) {
    var r = rootEl(); if (!r) return Promise.resolve();
    var sid = r.getAttribute('data-section-id');
    return fetch(location.pathname + '?section_id=' + encodeURIComponent(sid)).then(function (res) { return res.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-rscart]'); if (!fresh) { location.reload(); return; }
      var cur = rootEl(); cur.innerHTML = fresh.innerHTML;
      notify(); init(); if (after) after();
    }).catch(function () { location.reload(); });
  }

  function setQty(li, q) {
    li.classList.add('is-busy');
    var title = li.getAttribute('data-title'), vid = li.getAttribute('data-vid'), was = +li.getAttribute('data-qty');
    post('/cart/change.js', { id: li.getAttribute('data-key'), quantity: q }).then(function (cart) {
      var after = null;
      if (q === 0) { lastRemoved = { id: +vid, quantity: was, title: title }; after = function () { msg('Removed <b>' + esc(title) + '</b>. <button type="button" data-rscart-undo>Undo</button>'); }; }
      else {
        var line = (cart.items || []).filter(function (x) { return String(x.key) === li.getAttribute('data-key'); })[0];
        if (line && line.quantity < q) after = function () { msg('Only ' + line.quantity + ' of <b>' + esc(title) + '</b> available — quantity updated.', true); };
        else after = function () { msg(''); };
      }
      return refresh(after);
    }).catch(function (e) { li.classList.remove('is-busy'); msg(esc((e && (e.description || e.message)) || 'Sorry, that change did not go through. Please try again.'), true); var i = li.querySelector('[data-rscart-qty]'); if (i) i.value = was; });
  }

  var timers = {};
  document.addEventListener('click', function (e) {
    var r = rootEl(); if (!r || !r.contains(e.target)) return;
    var step = e.target.closest('[data-rscart-step]');
    if (step) {
      var li = step.closest('.rscart-item'), inp = li.querySelector('[data-rscart-qty]');
      inp.value = Math.max(0, (parseInt(inp.value, 10) || 0) + (+step.getAttribute('data-rscart-step')));
      var k = li.getAttribute('data-key'); clearTimeout(timers[k]); timers[k] = setTimeout(function () { setQty(li, parseInt(inp.value, 10) || 0); }, 380);
      return;
    }
    var rm = e.target.closest('[data-rscart-rm]'); if (rm) { setQty(rm.closest('.rscart-item'), 0); return; }
    if (e.target.closest('[data-rscart-undo]') && lastRemoved) {
      var lr = lastRemoved; lastRemoved = null; msg('Adding it back…');
      post('/cart/add.js', { items: [{ id: lr.id, quantity: lr.quantity }] }).then(function () { return refresh(function () { msg('<b>' + esc(lr.title) + '</b> is back in your basket.'); }); }).catch(function () { msg('Sorry, we could not add it back.', true); });
      return;
    }
    if (e.target.closest('[data-rscart-print]')) { window.print(); return; }
    var sh = e.target.closest('[data-rscart-share]');
    if (sh) {
      var link = location.origin + '/cart/' + items().map(function (x) { return x.vid + ':' + x.qty; }).join(',');
      var t = sh.querySelector('[data-rscart-share-t]');
      var done = function (ok) { if (t) { t.textContent = ok ? 'Link copied ✓' : link; setTimeout(function () { t.textContent = 'Copy basket link'; }, ok ? 2500 : 15000); } };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link).then(function () { done(true); }, function () { done(false); }); else done(false);
      return;
    }
    var add = e.target.closest('[data-rscart-add]');
    if (add) {
      add.disabled = true; add.textContent = 'Adding…';
      post('/cart/add.js', { items: [{ id: +add.getAttribute('data-rscart-add'), quantity: 1 }] }).then(function () { return refresh(function () { msg('Added to your basket.'); }); }).catch(function (er) { add.disabled = false; add.textContent = 'Add'; msg(esc((er && er.description) || 'Sorry, that item could not be added.'), true); });
    }
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest && e.target.closest('[data-rscart-qty]'); if (!inp || !rootEl() || !rootEl().contains(inp)) return;
    var li = inp.closest('.rscart-item'), k = li.getAttribute('data-key'); clearTimeout(timers[k]);
    setQty(li, Math.max(0, parseInt(inp.value, 10) || 0));
  });
  var noteT;
  document.addEventListener('input', function (e) {
    var n = e.target.closest && e.target.closest('[data-rscart-note]'); if (!n) return;
    var s = rootEl().querySelector('[data-rscart-note-s]'); if (s) s.textContent = '';
    clearTimeout(noteT); noteT = setTimeout(function () { post('/cart/update.js', { note: n.value }).then(function () { if (s) s.textContent = 'Saved'; }).catch(function () {}); }, 700);
  });

  function items() {
    var r = rootEl(); if (!r) return [];
    return Array.prototype.slice.call(r.querySelectorAll('.rscart-item')).map(function (li) { return { vid: li.getAttribute('data-vid'), pid: li.getAttribute('data-pid'), qty: +li.getAttribute('data-qty'), title: li.getAttribute('data-title'), price: (li.querySelector('.rscart-item__price b') || {}).textContent || '' }; });
  }

  function card(p, canAdd) {
    var img = p.featured_image ? (typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.url || p.featured_image.src) : '';
    if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
    var v = (p.variants || [])[0], single = p.variants && p.variants.length === 1 && v && v.available;
    var varies = p.price_varies || (p.price_min != null && p.price_max != null && p.price_min !== p.price_max);
    return '<div class="rscart-card"><a class="rscart-card__img" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
      '<a class="rscart-card__t" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<span class="rscart-card__p">' + (varies ? 'from ' : '') + money(p.price_min != null ? p.price_min : p.price) + '</span>' +
      (canAdd && single ? '<button type="button" class="rscart-card__b" data-rscart-add="' + v.id + '">Add</button>' : '<a class="rscart-card__b" href="' + esc(p.url) + '">' + (canAdd ? 'Choose options' : 'View') + '</a>') + '</div>';
  }

  function loadRecos() {
    var r = rootEl(); if (!r) return;
    var box = r.querySelector('[data-rscart-recos]'), row = r.querySelector('[data-rscart-recos-row]'); if (!box || !row) return;
    var its = items(); if (!its.length) return;
    var inCart = its.map(function (x) { return +x.pid; });
    var ids = its.map(function (x) { return x.pid; }).filter(function (v, i, a) { return a.indexOf(v) === i; }).slice(0, 2);
    Promise.all(ids.map(function (id) { return fetch('/recommendations/products.json?product_id=' + id + '&limit=8').then(function (x) { return x.json(); }).catch(function () { return { products: [] }; }); })).then(function (rs) {
      var seen = {}, out = [];
      rs.forEach(function (j) { (j.products || []).forEach(function (p) { if (inCart.indexOf(p.id) > -1 || seen[p.id] || !p.available) return; seen[p.id] = 1; out.push(p); }); });
      out = out.slice(0, 4); if (!out.length) return;
      row.innerHTML = out.map(function (p) { return card(p, true); }).join(''); box.hidden = false;
    });
  }

  function loadRecent() {
    var r = rootEl(); if (!r) return;
    var box = r.querySelector('[data-rscart-rv]'), row = r.querySelector('[data-rscart-rv-row]'); if (!box || !row) return;
    var rv = []; try { rv = JSON.parse(localStorage.getItem('rs_rv') || '[]') || []; } catch (e) {}
    rv = rv.filter(function (x) { return x && x.u; }).slice(0, 4); if (!rv.length) return;
    row.innerHTML = rv.map(function (x) {
      return '<div class="rscart-card"><a class="rscart-card__img" href="' + esc(x.u) + '">' + (x.i ? '<img src="' + esc(x.i) + '" alt="" loading="lazy">' : '') + '</a><a class="rscart-card__t" href="' + esc(x.u) + '">' + esc(x.t) + '</a><span class="rscart-card__p">' + (x.v ? 'from ' : '') + esc(x.p) + '</span><a class="rscart-card__b" href="' + esc(x.u) + '">View</a></div>';
    }).join('');
    box.hidden = false;
  }

  function waLink() {
    var r = rootEl(); if (!r) return; var a = r.querySelector('[data-rscart-wa]'); if (!a) return;
    var its = items(), tot = (r.querySelector('.rscart-sum__tot dd') || {}).textContent || '';
    var lines = its.map(function (x) { return '• ' + x.qty + ' × ' + x.title + ' (' + x.price.trim() + ')'; });
    var text = 'Hello Ramp Stockist, please could you check this basket for me:\n' + lines.join('\n') + (tot ? '\nBasket total: ' + tot.trim() : '');
    var base = a.getAttribute('href').split('?')[0];
    a.setAttribute('href', base + '?text=' + encodeURIComponent(text));
  }

  var io;
  function mbar() {
    var r = rootEl(); if (!r) return; var bar = r.querySelector('.rscart-mbar'), btn = r.querySelector('[data-rscart-checkout]'); if (!bar || !btn || !('IntersectionObserver' in window)) return;
    if (io) io.disconnect();
    io = new IntersectionObserver(function (es) { es.forEach(function (en) { bar.classList.toggle('is-hidden', en.isIntersecting); }); }); io.observe(btn);
  }

  function init() { loadRecos(); loadRecent(); waLink(); mbar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-rsc]'); if (!root || root.__rsc) return; root.__rsc = true;
  var cfg = {}; try { cfg = JSON.parse(root.querySelector('[data-rsc-cfg]').textContent); } catch (e) {}
  var grid = root.querySelector('[data-rsc-grid]'); if (!grid) return;
  var STEP = 12, shown = STEP, ready = false;
  var $ = function (s) { return root.querySelector(s); }, $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m]; }); }
  function fmt(n) { return Math.round(n).toLocaleString('en-GB'); }

  /* ---------- parse dimensions from the product title ---------- */
  var N = '(\\d{1,3}(?:,\\d{3})+|\\d+(?:\\.\\d+)?)';
  function num(s) { return parseFloat(String(s).replace(/,/g, '')); }
  function rx(s) { return new RegExp(s, 'i'); }
  var RE = {
    kg: new RegExp(N + '\\s*kg(?!\\s*\\/)(\\s*capacity)?', 'gi'),
    tonne: rx(N + '\\s*tonne'),
    lenR: rx(N + '\\s*mm\\s*(?:to|or|-)\\s*' + N + '\\s*mm\\s*(?:L\\b|Long\\b)'),
    lenPlus: rx(N + '\\s*mm\\s*\\+\\s*' + N + '\\s*mm\\s*L\\b'),
    len1: rx(N + '\\s*mm\\s*(?:L\\b|Long\\b)'),
    lenX: rx(N + '\\s*mm\\s*x\\s*' + N + '\\s*mm(?!\\s*(?:H\\b|High|Thick|Profile))'),
    lenR2: rx(N + '\\s*mm\\s*(?:to|-)\\s*' + N + '\\s*mm(?!\\s*(?:H\\b|High|Height|Rise|Load|Internal|Usable|W\\b|Wide))'),
    lenLead: /^\s*(\d{3,5})\s*mm\s+(?!H\b|High|Wide|W\b)/i,
    lenM: rx('(\\d+(?:\\.\\d+)?)\\s*m\\s*Long'),
    ftR: /(\d+(?:\.\d+)?)\s*ft\s*(?:to|-)\s*(\d+(?:\.\d+)?)\s*ft/i,
    ft1: /(\d+(?:\.\d+)?)\s*ft\b/i,
    wid: rx(N + '\\s*mm\\s*(?:(?:or|to|-)\\s*' + N + '\\s*mm\\s*)?(?:Internal\\s+|Usable\\s+)?(?:W\\b|Wide\\b|Width\\b)')
  };
  function parse(title) {
    var t = String(title).replace(/[–—]/g, '-'), m, out = {};
    var kgs = [], capKgs = [];
    RE.kg.lastIndex = 0;
    while ((m = RE.kg.exec(t))) { var v = num(m[1]); kgs.push(v); if (m[2]) capKgs.push(v); }
    var use = capKgs.length ? capKgs : kgs;
    if (use.length > 1) { var big = use.filter(function (v) { return v >= 30; }); if (big.length) use = big; }
    if (use.length) out.cap = [Math.min.apply(null, use), Math.max.apply(null, use)];
    else if ((m = t.match(RE.tonne))) { out.cap = [num(m[1]) * 1000, num(m[1]) * 1000]; }
    var xw = null;
    if ((m = t.match(RE.lenR))) out.len = [num(m[1]), num(m[2])];
    else if ((m = t.match(RE.lenPlus))) out.len = [num(m[1]) + num(m[2])];
    else if ((m = t.match(RE.len1))) out.len = [num(m[1])];
    else if ((m = t.match(RE.lenX))) { out.len = [num(m[1])]; xw = num(m[2]); }
    else if ((m = t.match(RE.lenR2)) && num(m[1]) >= 400) out.len = [num(m[1]), num(m[2])];
    else if ((m = t.match(RE.lenLead))) out.len = [num(m[1])];
    else if ((m = t.match(RE.lenM))) out.len = [num(m[1]) * 1000];
    else if ((m = t.match(RE.ftR))) out.len = [Math.round(num(m[1]) * 304.8), Math.round(num(m[2]) * 304.8)];
    else if ((m = t.match(RE.ft1))) out.len = [Math.round(num(m[1]) * 304.8)];
    if (out.len && out.len.length === 1) out.len.push(out.len[0]);
    if ((m = t.match(RE.wid))) out.wid = m[2] ? [num(m[1]), num(m[2])] : [num(m[1]), num(m[1])];
    else if (xw) out.wid = [xw, xw];
    return out;
  }

  /* ---------- items ---------- */
  var items = [];
  function collect() {
    items = $$('[data-rsc-card]').map(function (el) {
      var t = el.getAttribute('data-t') || '';
      var d = parse(t);
      return { el: el, i: +el.getAttribute('data-i'), t: t, lt: t.toLowerCase(), price: [+el.getAttribute('data-p'), +el.getAttribute('data-px')], cap: d.cap || null, len: d.len || null, wid: d.wid || null };
    });
    var seen = {};
    items = items.filter(function (it) { if (seen[it.i]) { it.el.remove(); return false; } seen[it.i] = 1; return true; });
    items.sort(function (a, b) { return a.i - b.i; });
  }

  /* ---------- keyword rules: "Label: kw, kw, -exclude" ---------- */
  function parseRules(txt) {
    return String(txt || '').split(/\n|~~/).map(function (line) {
      var i = line.indexOf(':'); if (i < 1) return null;
      var l = line.slice(0, i).trim(), inc = [], exc = [];
      line.slice(i + 1).split(',').forEach(function (k) { k = k.trim().toLowerCase(); if (!k) return; if (k.charAt(0) === '-') exc.push(k.slice(1).trim()); else inc.push(k); });
      return l ? { l: l, inc: inc, exc: exc } : null;
    }).filter(Boolean);
  }
  function kwTest(r) { return function (it) { return (!r.inc.length || r.inc.some(function (k) { return it.lt.indexOf(k) > -1; })) && !r.exc.some(function (k) { return it.lt.indexOf(k) > -1; }); }; }

  /* ---------- numeric buckets from the data ---------- */
  var NICE = {
    cap: [50, 100, 150, 200, 250, 300, 400, 500, 750, 1000, 1500, 2000, 2500, 3000, 4000, 5000, 6000, 8000, 10000, 12000, 15000, 20000, 30000, 40000],
    len: [300, 500, 750, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 5000, 6000, 8000, 10000],
    wid: [100, 200, 250, 300, 400, 500, 600, 750, 900, 1000, 1500, 2000],
    price: [2500, 5000, 10000, 25000, 50000, 75000, 100000, 150000, 250000, 500000, 750000, 1000000]
  };
  function buckets(key) {
    var have = items.filter(function (it) { return it[key]; });
    if (have.length < Math.max(3, items.length * 0.3)) return null;
    var vals = have.map(function (it) { return it[key][0]; }).sort(function (a, b) { return a - b; });
    var lo = vals[0], hi = vals[vals.length - 1]; if (hi <= lo) return null;
    var br = [];
    [0.2, 0.4, 0.6, 0.8].forEach(function (q) {
      var v = vals[Math.floor(q * (vals.length - 1))]; if (v <= 0) return;
      var best = null, bd = 1e9;
      NICE[key].forEach(function (n) { var d = Math.abs(Math.log(n / v)); if (d < bd) { bd = d; best = n; } });
      if (best > lo && best <= hi && br.indexOf(best) < 0) br.push(best);
    });
    br.sort(function (a, b) { return a - b; });
    if (!br.length) return null;
    var edges = [0].concat(br, [Infinity]), out = [];
    for (var i = 0; i < edges.length - 1; i++) out.push([edges[i], edges[i + 1]]);
    return out;
  }
  function unitFmt(key, v) { return key === 'price' ? '£' + fmt(v / 100) : fmt(v) + (key === 'cap' ? ' kg' : ' mm'); }
  function bucketLabel(key, b, i, n) {
    var lo = b[0], hi = b[1];
    var hiLbl = key === 'price' ? '£' + fmt(hi / 100 - 1) : fmt(hi - 1) + (key === 'cap' ? ' kg' : ' mm');
    if (i === 0) return 'Under ' + unitFmt(key, hi);
    if (i === n - 1) return unitFmt(key, lo) + ' +';
    return (key === 'price' ? '£' + fmt(lo / 100) : fmt(lo)) + ' – ' + hiLbl;
  }

  /* ---------- state ---------- */
  var groups = [], chips = [], sel = {}, chip = -1, finder = null;
  var STEEL = /steel tracks|milled|rubber coated/i;
  function build() {
    groups = [];
    var defs = [['cap', cfg.capLabel || 'Load rating'], ['len', cfg.load ? 'Ramp length' : 'Length'], ['wid', cfg.load ? 'Ramp width' : 'Width']];
    defs.forEach(function (d) {
      var bk = buckets(d[0]); if (!bk) return;
      var key = d[0];
      groups.push({ id: key, title: d[1], opts: bk.map(function (b, i) { return { l: bucketLabel(key, b, i, bk.length), test: function (it) { return it[key] && it[key][1] >= b[0] && it[key][0] < b[1]; } }; }) });
    });
    (cfg.facets || []).forEach(function (f, fi) {
      var rules = parseRules(f.o).map(function (r) { return { l: r.l, test: kwTest(r) }; });
      var live = rules.filter(function (o) { return items.some(o.test); });
      if (live.length > 1) groups.push({ id: 'k' + fi, title: f.t, opts: live });
    });
    var pb = buckets('price');
    if (pb) groups.push({ id: 'price', title: 'Price', opts: pb.map(function (b, i) { return { l: bucketLabel('price', b, i, pb.length), test: function (it) { return it.price[1] >= b[0] && it.price[0] < b[1]; } }; }) });
    groups.forEach(function (g) { sel[g.id] = []; });

    chips = parseRules(cfg.chips).map(function (r) { return { l: r.l, test: kwTest(r) }; }).filter(function (c) { return items.some(c.test); });

    var box = $('[data-rsc-groups]');
    box.innerHTML = groups.map(function (g) {
      return '<fieldset class="rsc-g"><legend>' + esc(g.title) + '</legend>' + g.opts.map(function (o, oi) {
        return '<label class="rsc-o"><input type="checkbox" data-g="' + g.id + '" data-o="' + oi + '"><span>' + esc(o.l) + '</span><small data-c></small></label>';
      }).join('') + '</fieldset>';
    }).join('') || '<p class="rsc-small">No filters for this range.</p>';
    box.addEventListener('change', function (e) {
      var c = e.target; if (!c.matches('input[data-g]')) return;
      var a = sel[c.getAttribute('data-g')], o = +c.getAttribute('data-o');
      if (c.checked) { if (a.indexOf(o) < 0) a.push(o); } else a.splice(a.indexOf(o), 1);
      shown = STEP; apply();
    });

    var cl = $('[data-rsc-chiplist]');
    if (chips.length) {
      cl.innerHTML = chips.map(function (c, i) { return '<button type="button" class="rsc-chip" aria-pressed="false" data-chip="' + i + '">' + esc(c.l) + ' <small data-c></small></button>'; }).join('');
      $('[data-rsc-chips]').hidden = false;
      cl.addEventListener('click', function (e) { var b = e.target.closest('[data-chip]'); if (!b) return; var i = +b.getAttribute('data-chip'); chip = chip === i ? -1 : i; shown = STEP; apply(); });
    }

    /* stats */
    var caps = items.filter(function (it) { return it.cap; }).map(function (it) { return it.cap[1]; });
    if (caps.length >= 3) {
      var mx = Math.max.apply(null, caps);
      setStat('cap', mx >= 1000 ? (Math.round(mx / 100) / 10).toString().replace(/\.0$/, '') + ' t' : fmt(mx) + ' kg');
    }
    var lens = items.filter(function (it) { return it.len; });
    if (lens.length >= 3) {
      var a = Math.min.apply(null, lens.map(function (it) { return it.len[0]; })), b = Math.max.apply(null, lens.map(function (it) { return it.len[1]; }));
      var m = function (v) { return (Math.round(v / 100) / 10).toString(); };
      if (b > a) setStat('len', m(a) + '–' + m(b) + ' m');
    }
    setStat('count', fmt(items.length), true);
    $$('[data-rsc-sort] option[data-needs]').forEach(function (o) { if (!groups.some(function (g) { return g.id === o.getAttribute('data-needs'); })) o.remove(); });
  }
  function setStat(k, v, keep) { var b = root.querySelector('[data-rsc-stat="' + k + '"]'); if (!b) return; b.textContent = v; if (!keep) { var w = root.querySelector('[data-rsc-statwrap="' + k + '"]'); if (w) w.hidden = false; } }

  function finderOk(it) { return it.cap && it.cap[1] >= finder.cap && it.len && it.len[1] >= finder.len && (!finder.steel || STEEL.test(it.t)); }
  function match(it, skip) {
    for (var g = 0; g < groups.length; g++) {
      var G = groups[g], s = sel[G.id];
      if (G.id === skip || !s.length) continue;
      if (!s.some(function (o) { return G.opts[o].test(it); })) return false;
    }
    if (skip !== 'chip' && chip > -1 && !chips[chip].test(it)) return false;
    if (skip !== 'finder' && finder && !finderOk(it)) return false;
    return true;
  }
  var sortSel = $('[data-rsc-sort]');
  function cmp(a, b) {
    switch (sortSel.value) {
      case 'price-asc': return a.price[0] - b.price[0] || a.i - b.i;
      case 'price-desc': return b.price[0] - a.price[0] || a.i - b.i;
      case 'cap-desc': return (b.cap ? b.cap[1] : -1) - (a.cap ? a.cap[1] : -1) || a.i - b.i;
      case 'len-asc': return (a.len ? a.len[0] : 1e9) - (b.len ? b.len[0] : 1e9) || a.i - b.i;
      default: return a.i - b.i;
    }
  }

  function apply() {
    var list = items.filter(function (it) { return match(it); }).sort(cmp);
    var rest = items.filter(function (it) { return list.indexOf(it) < 0; });
    var frag = document.createDocumentFragment();
    list.forEach(function (it, i) { it.el.hidden = i >= shown; frag.appendChild(it.el); });
    rest.forEach(function (it) { it.el.hidden = true; frag.appendChild(it.el); });
    grid.appendChild(frag);

    var n = list.length, vis = Math.min(shown, n);
    $('[data-rsc-countline]').innerHTML = '<b>' + fmt(n) + '</b> ' + esc(cfg.noun || 'products') + ' · showing ' + fmt(vis);
    $('[data-rsc-empty]').hidden = n > 0;
    $('[data-rsc-morewrap]').hidden = vis >= n;

    groups.forEach(function (G) {
      G.opts.forEach(function (o, oi) {
        var c = items.filter(function (it) { return match(it, G.id) && o.test(it); }).length;
        var inp = root.querySelector('input[data-g="' + G.id + '"][data-o="' + oi + '"]'); if (!inp) return;
        var on = sel[G.id].indexOf(oi) > -1;
        inp.checked = on; inp.disabled = !c && !on;
        inp.parentNode.classList.toggle('is-off', !c && !on);
        inp.parentNode.querySelector('[data-c]').textContent = c;
      });
    });
    chips.forEach(function (c, i) {
      var b = root.querySelector('[data-chip="' + i + '"]'); if (!b) return;
      b.setAttribute('aria-pressed', String(chip === i));
      b.querySelector('[data-c]').textContent = items.filter(function (it) { return match(it, 'chip') && c.test(it); }).length;
    });

    var pills = [], nsel = 0;
    groups.forEach(function (G) { sel[G.id].forEach(function (o) { nsel++; pills.push('<button type="button" class="rsc-ap" data-rm="' + G.id + ':' + o + '">' + esc(G.opts[o].l) + ' <i aria-hidden="true">×</i></button>'); }); });
    if (chip > -1) { nsel++; pills.push('<button type="button" class="rsc-ap" data-rm="chip">' + esc(chips[chip].l) + ' <i aria-hidden="true">×</i></button>'); }
    if (finder) { nsel++; pills.push('<button type="button" class="rsc-ap" data-rm="finder">Finder: ' + fmt(finder.cap) + ' kg+ · ' + fmt(finder.len) + ' mm+' + (finder.steel ? ' · steel tracks' : '') + ' <i aria-hidden="true">×</i></button>'); }
    var act = $('[data-rsc-active]'); act.innerHTML = pills.join(''); act.hidden = !pills.length;
    $$('[data-rsc-clear]').forEach(function (b) { if (b.closest('.rsc-side__head')) b.hidden = !nsel; });
    $('[data-rsc-fcount]').textContent = nsel || '';
    var sb = $('[data-rsc-showbtn]'); if (sb) sb.textContent = 'Show ' + fmt(n) + ' result' + (n === 1 ? '' : 's');
  }

  function clearAll() { groups.forEach(function (G) { sel[G.id] = []; }); chip = -1; finder = null; shown = STEP; apply(); }
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-rm],[data-rsc-clear],[data-rsc-more]'); if (!t || !ready) return;
    if (t.hasAttribute('data-rsc-clear')) { clearAll(); return; }
    if (t.hasAttribute('data-rsc-more')) { shown += STEP; apply(); return; }
    var r = t.getAttribute('data-rm');
    if (r === 'chip') chip = -1; else if (r === 'finder') finder = null;
    else { var p = r.split(':'), a = sel[p[0]]; a.splice(a.indexOf(+p[1]), 1); }
    shown = STEP; apply();
  });
  sortSel.addEventListener('change', function () { if (ready) { shown = Math.max(shown, STEP); apply(); } });

  /* ---------- mobile filter drawer ---------- */
  var side = $('[data-rsc-side]'), sbg = root.querySelector('.rsc-side__bg'), ob = $('[data-rsc-openf]');
  function openF() { side.classList.add('is-open'); sbg.hidden = false; ob.setAttribute('aria-expanded', 'true'); document.documentElement.style.overflow = 'hidden'; }
  function closeF() { if (!side.classList.contains('is-open')) return; side.classList.remove('is-open'); sbg.hidden = true; ob.setAttribute('aria-expanded', 'false'); document.documentElement.style.overflow = ''; }
  ob.addEventListener('click', openF);
  $$('[data-rsc-closef]').forEach(function (b) { b.addEventListener('click', closeF); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeF(); });

  /* ---------- ramp finder ---------- */
  var fd = $('[data-rsc-finder]');
  function calc() {
    var r = fd.querySelector('input[name="rsc-m"]:checked') || fd.querySelector('input[name="rsc-m"]');
    var deg = +r.getAttribute('data-deg'), w = Math.max(0, +fd.querySelector('[data-rsc-w]').value || 0), h = Math.max(0, +fd.querySelector('[data-rsc-h]').value || 0);
    var c = Math.ceil(w * 1.25 / 100) * 100, L = Math.ceil(h / Math.tan(deg * Math.PI / 180) / 100) * 100;
    fd.querySelector('[data-rsc-ocap]').textContent = fmt(c) + ' kg';
    fd.querySelector('[data-rsc-olen]').textContent = fmt(L) + ' mm';
    fd.querySelector('[data-rsc-onote]').textContent = r.getAttribute('data-note');
    return { cap: c, len: L, steel: r.getAttribute('data-steel') === '1' };
  }
  if (fd) {
    fd.addEventListener('input', calc); fd.addEventListener('change', calc); calc();
    fd.querySelector('[data-rsc-fgo]').addEventListener('click', function () {
      var go = function () { finder = calc(); chip = -1; shown = STEP; apply(); var bar = root.querySelector('.rsc-bar'); if (bar) bar.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
      if (ready) go(); else root.__pending = go;
    });
  }

  /* ---------- add to basket ---------- */
  var toast = $('[data-rsc-toast]'), tt;
  function showToast(msg) { $('[data-rsc-toastmsg]').textContent = msg; toast.hidden = false; clearTimeout(tt); tt = setTimeout(function () { toast.hidden = true; }, 5000); }
  $('[data-rsc-toastx]').addEventListener('click', function () { toast.hidden = true; });
  grid.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-rsc-add]'); if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('button'), txt = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +f.querySelector('[name=id]').value, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        btn.textContent = 'Added ✓'; showToast('Added to basket');
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'rs-collection', data: { source: 'rs-collection', itemCount: cart.item_count } } }));
        setTimeout(function () { btn.textContent = txt; btn.disabled = false; }, 1800);
      })
      .catch(function (err) { btn.textContent = txt; btn.disabled = false; showToast((err && (err.description || err.message)) || 'Could not add to basket'); });
  });

  /* ---------- load every page in the background, then build filters ---------- */
  var pages = +grid.getAttribute('data-pages') || 1, cur = +grid.getAttribute('data-page') || 1, reqs = [];
  for (var p = 1; p <= pages && p <= 6; p++) {
    if (p === cur) continue;
    reqs.push(fetch(location.pathname + '?section_id=' + encodeURIComponent(cfg.sid) + '&page=' + p).then(function (r) { return r.text(); }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html');
      d.querySelectorAll('[data-rsc-card]').forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
    }).catch(function () {}));
  }
  Promise.all(reqs).then(function () {
    collect(); build(); ready = true; root.classList.add('rsc-ready'); apply();
    if (root.__pending) { root.__pending(); root.__pending = null; }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-rsc]'); if (!root || root.__rsc) return; root.__rsc = true;

  /* topic → which extra fields show (hidden ones are disabled so they are not posted) */
  var radios = Array.prototype.slice.call(root.querySelectorAll('[data-rsc-topic]'));
  var show = {
    'Help choosing a ramp': ['choose'],
    'Price for a project or bulk order': ['quote'],
    'Question about an order': ['order'],
    'Problem with an item': ['order', 'item'],
    'Trade account': [],
    'Something else': []
  };
  var hints = {
    'Help choosing a ramp': 'Anything else we should know — doorway width, surface, how often it will be moved?',
    'Price for a project or bulk order': 'When do you need it, and is it for one site or several?',
    'Question about an order': 'What would you like us to check?',
    'Problem with an item': 'What has happened? A photo on WhatsApp helps us sort it quickly.',
    'Trade account': 'What do you buy, and roughly how often?',
    'Something else': 'How can we help?'
  };
  var msg = root.querySelector('textarea[name="contact[body]"]');
  function paint() {
    var on = radios.filter(function (r) { return r.checked; })[0], v = on ? on.value : '', keep = show[v] || [];
    root.querySelectorAll('[data-rsc-f]').forEach(function (el) {
      var vis = keep.indexOf(el.getAttribute('data-rsc-f')) > -1; el.hidden = !vis;
      el.querySelectorAll('input,select,textarea').forEach(function (i) { if (i.hasAttribute('data-rsc-sugg')) return; i.disabled = !vis; });
    });
    if (msg) msg.placeholder = hints[v] || '';
    calc();
  }
  radios.forEach(function (r) { r.addEventListener('change', paint); });

  /* live ramp length suggestion */
  var use = root.querySelector('[data-rsc-use]'), h = root.querySelector('[data-rsc-h]'), hint = root.querySelector('[data-rsc-hint]'), sug = root.querySelector('[data-rsc-sugg]');
  function fmt(n) { return (Math.ceil(n / 10) * 10).toLocaleString('en-GB'); }
  function calc() {
    if (!use || !h || !hint) return;
    var box = root.querySelector('[data-rsc-f="choose"]'), v = parseFloat(h.value), opt = use.options[use.selectedIndex], mode = opt ? opt.getAttribute('data-mode') : '', url = opt ? opt.getAttribute('data-url') : '';
    if (!box || box.hidden || !(v > 0) || !mode) { hint.hidden = true; hint.innerHTML = ''; if (sug) { sug.value = ''; sug.disabled = true; } return; }
    var a, b, txt;
    if (mode === 'access') { a = fmt(v * 15); b = fmt(v * 12); txt = 'For ' + Math.round(v) + 'mm you\'ll want about <b>' + a + ' mm</b> of ramp at a gentle 1:15, or <b>' + b + ' mm</b> at 1:12 (the steepest usual for wheelchairs).'; if (sug) sug.value = a + ' mm at 1:15 / ' + b + ' mm at 1:12'; }
    else { a = fmt(v / Math.tan(15 * Math.PI / 180)); b = fmt(v / Math.tan(10 * Math.PI / 180)); txt = 'For ' + Math.round(v) + 'mm you\'ll want about <b>' + a + ' mm</b> of ramp at 15°, or <b>' + b + ' mm</b> at a gentler 10° (better for low cars and heavy machines).'; if (sug) sug.value = a + ' mm at 15° / ' + b + ' mm at 10°'; }
    if (url) txt += ' <a href="' + url + '">Browse ' + opt.getAttribute('data-label') + ' →</a>';
    hint.innerHTML = txt; hint.hidden = false; if (sug) sug.disabled = false;
  }
  if (use) use.addEventListener('change', calc);
  if (h) h.addEventListener('input', calc);
  if (radios.length) paint();

  /* open / closed status in UK time */
  var st = root.querySelector('[data-rsc-status]');
  if (st && window.Intl) {
    var DN = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var hm = function (s) { var m = String(s || '').match(/(\d{1,2})[:.](\d{2})/); return m ? (+m[1]) * 60 + (+m[2]) : null; };
    var upd = function () {
      var days = (st.getAttribute('data-days') || '').split(',').map(function (x) { return +x; }), o = hm(st.getAttribute('data-open')), c = hm(st.getAttribute('data-close'));
      if (o == null || c == null) return;
      var p = {}; try { new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; }); } catch (e) { return; }
      var d = DN.indexOf(p.weekday), now = (+p.hour % 24) * 60 + (+p.minute), ot = st.getAttribute('data-open'), ct = st.getAttribute('data-close'), txt, open = false;
      if (d < 0) return;
      if (days.indexOf(d) > -1 && now >= o && now < c) { open = true; txt = 'Open now · lines open until ' + ct; }
      else if (days.indexOf(d) > -1 && now < o) txt = 'Closed now · opens today at ' + ot;
      else { for (var i = 1; i <= 7; i++) { var nd = (d + i) % 7; if (days.indexOf(nd) > -1) { txt = 'Closed now · opens ' + (i === 1 ? 'tomorrow' : DN[nd]) + ' at ' + ot; break; } } }
      if (!txt) return; st.textContent = txt; st.classList.toggle('is-open', open); st.classList.toggle('is-shut', !open);
    };
    upd(); setInterval(upd, 60000);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-header"]) return;
  try {
    
(function () {
  var root = document.querySelector('[data-rshd]'); if (!root || root.__rshd) return; root.__rshd = true;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m]; }); }
  function store(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k) || 'null'); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }

  /* mega menu */
  var items = Array.prototype.slice.call(root.querySelectorAll('[data-rshd-item]'));
  function closeAll(except) { items.forEach(function (it) { if (it !== except) { it.classList.remove('is-open'); var l = it.querySelector('[data-rshd-link]'); if (l) l.setAttribute('aria-expanded', 'false'); } }); }
  items.forEach(function (it) {
    var link = it.querySelector('[data-rshd-link]'), panel = it.querySelector('[data-rshd-panel]');
    if (!panel) return;
    var t;
    function open() { clearTimeout(t); closeAll(it); it.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); }
    it.addEventListener('mouseenter', function () { clearTimeout(t); t = setTimeout(open, 90); });
    it.addEventListener('mouseleave', function () { clearTimeout(t); t = setTimeout(function () { if (panel.contains(document.activeElement) && document.activeElement.tagName === 'INPUT') return; it.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); }, 160); });
    link.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: none)').matches && !it.classList.contains('is-open')) { e.preventDefault(); open(); }
    });
    link.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); open(); var f = panel.querySelector('a,input'); if (f) f.focus(); } });
    it.addEventListener('focusout', function (e) { if (!it.contains(e.relatedTarget)) { it.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); } });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); closeDrawer(); } });
  document.addEventListener('click', function (e) { if (!root.contains(e.target)) closeAll(); });

  /* ramp length tool inside the mega panels */
  function fmt(n) { return Math.round(n).toLocaleString('en-GB'); }
  root.querySelectorAll('[data-rshd-tool]').forEach(function (tool) {
    var mode = tool.getAttribute('data-rshd-tool'), inp = tool.querySelector('[data-rshd-rise]'), out = tool.querySelector('[data-rshd-out]'), first = out.innerHTML;
    var url = tool.getAttribute('data-url'), label = tool.getAttribute('data-label');
    inp.addEventListener('input', function () {
      var h = parseFloat(inp.value);
      if (!(h > 0)) { out.innerHTML = first; return; }
      var up = function (n) { return Math.ceil(n / 10) * 10; };
      var html;
      if (mode === 'loading') {
        html = 'At 15°: about <b>' + fmt(up(h / Math.tan(15 * Math.PI / 180))) + ' mm</b> of ramp<br>At a gentler 10°: about <b>' + fmt(up(h / Math.tan(10 * Math.PI / 180))) + ' mm</b>';
      } else {
        html = 'At 1:15: about <b>' + fmt(up(h * 15)) + ' mm</b> of ramp<br>At 1:12 (steepest usual for wheelchairs): about <b>' + fmt(up(h * 12)) + ' mm</b>';
      }
      out.innerHTML = html + '<br><a href="' + esc(url) + '">See ' + esc(label) + ' →</a>';
    });
  });

  /* drawer */
  var drawer = root.querySelector('[data-rshd-drawer]'), openBtn = root.querySelector('[data-rshd-open]');
  function openDrawer() { drawer.hidden = false; document.documentElement.style.overflow = 'hidden'; openBtn.setAttribute('aria-expanded', 'true'); var x = drawer.querySelector('.rshd-drawer__x'); if (x) x.focus(); }
  function closeDrawer() { if (!drawer || drawer.hidden) return; drawer.hidden = true; document.documentElement.style.overflow = ''; openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); }
  if (openBtn && drawer) { openBtn.addEventListener('click', openDrawer); drawer.querySelectorAll('[data-rshd-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); }); }

  /* open / closed status in UK time */
  (function () {
    var els = root.querySelectorAll('[data-rshd-status]'); if (!els.length || !window.Intl) return;
    var DN = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    function hm(s) { var m = String(s || '').match(/(\d{1,2})[:.](\d{2})/); return m ? (+m[1]) * 60 + (+m[2]) : null; }
    function upd() {
      els.forEach(function (el) {
        var days = (el.getAttribute('data-days') || '').split(',').map(function (x) { return +x; }), o = hm(el.getAttribute('data-open')), c = hm(el.getAttribute('data-close'));
        if (o == null || c == null || !days.length) return;
        var parts = {}; try { new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; }); } catch (e) { return; }
        var d = DN.indexOf(parts.weekday), now = (+parts.hour % 24) * 60 + (+parts.minute);
        if (d < 0) return;
        var openTxt = el.getAttribute('data-open'), closeTxt = el.getAttribute('data-close'), txt, isOpen = false;
        if (days.indexOf(d) > -1 && now >= o && now < c) { isOpen = true; txt = 'Open now · until ' + closeTxt; }
        else if (days.indexOf(d) > -1 && now < o) { txt = 'Closed · opens today ' + openTxt; }
        else { for (var i = 1; i <= 7; i++) { var nd = (d + i) % 7; if (days.indexOf(nd) > -1) { txt = 'Closed · opens ' + (i === 1 ? 'tomorrow' : DN[nd]) + ' ' + openTxt; break; } } }
        if (!txt) return;
        el.textContent = txt; el.classList.toggle('is-open', isOpen); el.classList.toggle('is-shut', !isOpen);
      });
    }
    upd(); setInterval(upd, 60000);
  })();

  /* recently viewed (stored on product pages) */
  var rvEl = root.querySelector('[data-rshd-rv]'), curH = '';
  if (rvEl) { try { var me = JSON.parse(rvEl.textContent); curH = me.h; var list = (store('rs_rv') || []).filter(function (x) { return x && x.h !== me.h; }); list.unshift(me); store('rs_rv', list.slice(0, 8)); } catch (e) {} }

  /* search: unit-aware, ranges + products, empty-state, "/" shortcut, rotating examples */
  var form = root.querySelector('[data-rshd-search]'), q = root.querySelector('[data-rshd-q]'), sugg = root.querySelector('[data-rshd-sugg]'), popT = root.querySelector('[data-rshd-pop]');
  var known = []; try { known = JSON.parse((root.querySelector('[data-rshd-cols]') || {}).textContent || '[]'); } catch (e) {}
  function stem(w) { return w.replace(/(es|s)$/, ''); }
  function localRanges(term) {
    var words = term.toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').split(/\s+/).filter(Boolean).map(stem);
    return known.filter(function (c) { var tw = c.t.toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').split(/\s+/).filter(function (w) { return w && w !== 'and'; }).map(stem); return tw.length && tw.every(function (w) { return words.indexOf(w) > -1; }); });
  }
  function money(v) { var n = Number(v); return isNaN(n) ? String(v) : '£' + n.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function norm(s) {
    return String(s)
      .replace(/(\d+(?:\.\d+)?)\s*(?:tonnes?|tons?|t)\b/gi, function (m, n) { return Math.round(parseFloat(n) * 1000) + 'kg'; })
      .replace(/(\d+(?:\.\d+)?)\s*cm\b/gi, function (m, n) { return Math.round(parseFloat(n) * 10) + 'mm'; })
      .replace(/(\d+(?:\.\d+)?)\s*(?:metres?|meters?|m)\b/gi, function (m, n) { return Math.round(parseFloat(n) * 1000) + 'mm'; });
  }
  if (form && q && sugg) {
    var timer, lastQ = null, idx = -1, action = form.getAttribute('action');
    var hide = function () { sugg.hidden = true; sugg.innerHTML = ''; q.setAttribute('aria-expanded', 'false'); idx = -1; lastQ = null; };
    var show = function (html) { sugg.innerHTML = html; sugg.hidden = false; q.setAttribute('aria-expanded', 'true'); idx = -1; };
    var emptyState = function () {
      var html = '', rv = (store('rs_rv') || []).filter(function (x) { return x && x.h !== curH; }).slice(0, 4);
      if (rv.length) {
        html += '<span class="rshd-sugg__h">Recently viewed</span>';
        rv.forEach(function (p) { html += '<a class="rshd-sugg__p" href="' + esc(p.u) + '">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy">' : '') + '<span>' + esc(p.t) + '</span><b>' + (p.v ? 'from ' : '') + esc(p.p) + '</b></a>'; });
      }
      if (popT && popT.innerHTML.trim()) html += '<span class="rshd-sugg__h">Popular ranges</span><div class="rshd-sugg__chips">' + popT.innerHTML + '</div>';
      if (html) { show(html); lastQ = ''; } else hide();
    };
    var fetchSugg = function () {
      var raw = q.value.trim();
      if (raw.length < 2) { if (document.activeElement === q && !raw) emptyState(); else hide(); return; }
      var term = norm(raw);
      if (term === lastQ) return; lastQ = term;
      fetch(action + '/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product,collection&resources[limit]=6&resources[limit_scope]=each')
        .then(function (r) { return r.json(); }).then(function (j) {
          if (lastQ !== term) return;
          var res = (j && j.resources && j.resources.results) || {}, ps = res.products || [], cs = (res.collections || []).filter(function (c) { return c.title && c.url; });
          localRanges(term).forEach(function (k) { if (!cs.some(function (c) { return c.url.split('?')[0] === k.u; })) cs.unshift({ title: k.t, url: k.u }); });
          var html = '';
          if (term !== raw) html += '<div class="rshd-sugg__note">Searching for <b>' + esc(term) + '</b></div>';
          if (cs.length) { html += '<span class="rshd-sugg__h">Ranges</span><div class="rshd-sugg__chips">'; cs.slice(0, 5).forEach(function (c) { html += '<a class="rshd-chip" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }); html += '</div>'; }
          if (ps.length) {
            html += '<span class="rshd-sugg__h">Products</span>';
            ps.forEach(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
              var price = p.price ? (/^\d+(\.\d+)?$/.test(String(p.price)) ? money(p.price) : p.price) : '';
              var varies = p.price_min != null && p.price_max != null && p.price_min !== p.price_max;
              html += '<a class="rshd-sugg__p" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=100" alt="" loading="lazy">' : '') + '<span>' + esc(p.title) + '</span>' + (price ? '<b>' + (varies ? 'from ' : '') + esc(price) + '</b>' : '') + '</a>';
            });
          }
          if (!ps.length && !cs.length) html += '<div class="rshd-sugg__note">No quick matches — press Enter to search everything.</div>';
          html += '<a class="rshd-sugg__all" href="' + action + '?type=product&q=' + encodeURIComponent(term) + '">See all results for “' + esc(term) + '” →</a>';
          show(html);
        }).catch(hide);
    };
    q.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(fetchSugg, 180); });
    q.addEventListener('focus', function () { if (!q.value.trim()) emptyState(); else fetchSugg(); });
    q.addEventListener('keydown', function (e) {
      var links = sugg.hidden ? [] : Array.prototype.slice.call(sugg.querySelectorAll('a'));
      if (e.key === 'Escape') { hide(); q.blur(); return; }
      if (!links.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); idx = Math.min(links.length - 1, idx + 1); } else if (e.key === 'ArrowUp') { e.preventDefault(); idx = Math.max(0, idx - 1); } else if (e.key === 'Enter' && idx >= 0) { e.preventDefault(); location.href = links[idx].href; return; } else return;
      links.forEach(function (a, i) { a.classList.toggle('is-on', i === idx); });
      if (links[idx]) links[idx].scrollIntoView({ block: 'nearest' });
    });
    form.addEventListener('submit', function () { var v = q.value.trim(); if (v) q.value = norm(v); });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) hide(); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
      var a = document.activeElement, tag = a && a.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (a && a.isContentEditable)) return;
      e.preventDefault(); q.focus();
    });
    /* rotating example searches in the placeholder */
    var ex = (q.getAttribute('data-examples') || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean), base = q.getAttribute('placeholder'), ei = 0;
    if (ex.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setInterval(function () {
        if (q.value || document.activeElement === q || document.hidden) return;
        q.classList.add('is-swap');
        setTimeout(function () { q.setAttribute('placeholder', 'Try “' + ex[ei % ex.length] + '”'); ei++; q.classList.remove('is-swap'); }, 250);
      }, 3200);
    }
  }

  /* keep the range links clear of the quote link: tighten step by step until they fit */
  (function () {
    var nav = root.querySelector('.rshd-nav'), list = root.querySelector('.rshd-nav__list'), inner = root.querySelector('.rshd-nav__in'), quote = root.querySelector('.rshd-nav__quote');
    if (!nav || !list || !inner) return;
    function over() { var qw = quote ? quote.getBoundingClientRect().width : 0, gap = parseFloat(getComputedStyle(inner).columnGap) || 0; return list.scrollWidth + qw + gap > inner.clientWidth - parseFloat(getComputedStyle(inner).paddingLeft) - parseFloat(getComputedStyle(inner).paddingRight) + 1; }
    function fit() {
      if (getComputedStyle(nav).display === 'none') return;
      nav.classList.remove('t1', 't2', 't3', 't4');
      ['t1', 't2', 't3'].some(function (c) { if (!over()) return true; nav.classList.add(c); return false; });
    }
    fit(); window.addEventListener('resize', function () { clearTimeout(fit._t); fit._t = setTimeout(fit, 80); }); window.addEventListener('load', fit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  })();

  /* sticky header height for other sections */
  var scroller = document.querySelector('.page-wrapper'), tick = false, grp = document.getElementById('header-group');
  function measure() { if (grp) document.documentElement.style.setProperty('--rs-header-h', Math.round(grp.getBoundingClientRect().height) + 'px'); }
  /* hysteresis: collapsing the top bar shortens the page and scroll anchoring moves scrollY by the bar height,
     so a single threshold flips is-stuck on and off every frame (the header "vibrates"). Stick past 120px, unstick only near the top. */
  function onScroll() { if (tick) return; tick = true; requestAnimationFrame(function () { tick = false; var y = Math.max(window.pageYOffset || 0, scroller ? scroller.scrollTop : 0); var was = root.classList.contains('is-stuck'), now = was ? y > 8 : y > 120; if (was === now) return; root.classList.toggle('is-stuck', now); setTimeout(measure, 230); }); }
  measure(); window.addEventListener('resize', measure); window.addEventListener('load', measure);
  var topBar = root.querySelector('.rshd-top'); if (topBar) topBar.addEventListener('transitionend', measure);
  window.addEventListener('scroll', onScroll, { passive: true }); if (scroller) scroller.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  function refreshCount() { fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { var n = root.querySelector('[data-rshd-count]'); if (n) n.textContent = c.item_count; }).catch(function () {}); }
  ['cart:update', 'cart:refresh', 'cart-update', 'cart:change', 'rs:cart'].forEach(function (t) { document.addEventListener(t, refreshCount); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rs-home"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-rsh]'); if (!root || root.__rsh) return; root.__rsh = true;
  /* ---- ramp length finder ---- */
  var f = root.querySelector('[data-rsh-finder]');
  if (f) {
    var dest = {}; try { dest = JSON.parse(f.querySelector('[data-rsh-dest]').textContent); } catch (e) {}
    var rise = f.querySelector('[data-rsh-rise]'), rv = f.querySelector('[data-rsh-riseval] b');
    var lenEl = f.querySelector('[data-rsh-len]'), subEl = f.querySelector('[data-rsh-sub]'), lab = f.querySelector('[data-rsh-reslabel]'), go = f.querySelector('[data-rsh-go]'), wedge = f.querySelector('[data-rsh-wedge]');
    var radios = Array.prototype.slice.call(f.querySelectorAll('input[name="rsh-who"]'));
    var paint = function () {
      var on = radios.filter(function (r) { return r.checked; })[0] || radios[0];
      var n = +on.value, h = +rise.value, mm = h * n;
      rv.textContent = h;
      var deg = Math.atan(1 / n) * 180 / Math.PI;
      lab.textContent = 'Minimum ramp length at 1:' + n + ' (' + deg.toFixed(1) + '°)';
      lenEl.textContent = (mm / 1000).toFixed(2) + ' m';
      subEl.textContent = mm.toLocaleString('en-GB') + ' mm · about ' + (mm / 304.8).toFixed(1) + ' ft';
      var y = Math.max(2, Math.min(32, 32 / n * 2.4));
      wedge.setAttribute('d', 'M4 36 H116 V' + (36 - y).toFixed(1) + ' Z');
      var d = on.getAttribute('data-dest'), t;
      if (d === 'step') t = (dest.thr && h <= dest.thr.max) ? dest.thr : dest.wc;
      else if (d === 'car') t = dest.car; else t = dest.load;
      if (t && t.u) { go.href = t.u; go.firstChild.nodeValue = 'Shop ' + String(t.t || '').toLowerCase() + ' '; }
    };
    radios.forEach(function (r) { r.addEventListener('change', paint); });
    rise.addEventListener('input', paint);
    f.querySelectorAll('[data-rsh-step]').forEach(function (b) { b.addEventListener('click', function () { rise.value = Math.max(+rise.min, Math.min(+rise.max, +rise.value + +b.getAttribute('data-rsh-step'))); paint(); }); });
    paint();
  }
  /* ---- popular picks tabs ---- */
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-rsh-tab]'));
  function sel(btn) {
    tabs.forEach(function (b) { var on = b === btn; b.setAttribute('aria-selected', String(on)); b.tabIndex = on ? 0 : -1; var p = root.querySelector('#' + b.getAttribute('aria-controls')); if (p) p.hidden = !on; });
  }
  tabs.forEach(function (b, i) {
    b.addEventListener('click', function () { sel(b); });
    b.addEventListener('keydown', function (e) { var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!k) return; e.preventDefault(); var n = tabs[(i + k + tabs.length) % tabs.length]; sel(n); n.focus(); });
  });
  /* quote form: reopen at the form after a post */
  if (/contact_posted=true/.test(location.search) || root.querySelector('.rsh-qf__err')) { var q = root.querySelector('#rs-quote'); if (q) q.scrollIntoView(); }
})();

  } catch(e) { console.error(e); }
})();
})();
